module.exports = __webpack_public_path__ + "static/gavazzi-logo-cee9f73306f0b4c4e1f5901cdccae880.png";